// extracted by mini-css-extract-plugin
export var button = "_6t-0";
export var icon = "_6t-1";